import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force password change for first-login / seeded users
  if (
    user.must_change_password &&
    location.pathname !== "/account/password"
  ) {
    return <Navigate to="/account/password" replace state={{ forced: true }} />;
  }

  return children;
}
